import { IconBuilding, IconFilePlus, IconLayers, IconTruck, IconInbox } from './sidebarIcons';
import Sidebar from '../components/SidebarNext';

const NAV = [
    { to: '/dms', label: 'Uprising Inventory', icon: <IconBuilding />, end: true },
    { to: '/dms/fatehpuria-inventory', label: 'Fatehpuria Inventory', icon: <IconTruck /> },
    { to: '/dms/choudhary-inventory', label: 'Choudhary Inventory', icon: <IconInbox /> },
    { to: '/dms/distributor-po', label: 'Distributor Purchase Orders', icon: <IconFilePlus /> },
    { to: '/dms/distributor-master', label: 'Distributor Master', icon: <IconLayers /> },
];

export default function DMSLayout({ user, onLogout, children }) {
    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#FAF8FC' }}>
            <Sidebar navItems={NAV} sectionLabel="DMS" homeHref="/landing" user={user} domainKey="dms" />
            <div id="sbn-main" className="sbn-content"
                 style={{ flex: 1, minWidth: 0, padding: '28px 32px', overflowY: 'auto', height: '100%' }}>
                {children}
            </div>
        </div>
    );
}